import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { Observable, Subject } from 'rxjs';
import { debounceTime, map, startWith, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'np-mat-autocomplete-hybrid',
  templateUrl: './mat-autocomplete-hybrid.component.html',
  styleUrls: ['./mat-autocomplete-hybrid.component.scss']
})
export class MatAutocompleteHybridComponent implements OnInit, OnDestroy, OnChanges {
  @Input() selectControl: FormControl;
  @Input() placeholder: string;
  @Input() class: string;
  @Input() inputClass: string;
  @Input() data: Array<any>;
  @Input() dataDisplayValue: string;
  @Input() readonly = false;

  selectedValue = null;
  filteredOptions: Observable<any>;
  @Output() selecteOptionChanged: EventEmitter<any> = new EventEmitter();
  _onDestroy: Subject<void>;
  isFocus: boolean;

  constructor() {
    this._onDestroy = new Subject<void>();
  }

  ngOnInit(): void {
    if (this.selectControl.value && this.data && this.data.length > 0) {
      const value = this.data.find(item => item[this.dataDisplayValue].toLowerCase() === this.selectControl.value.toLowerCase());
      this.selectedValue = value || null;
    }

    this.filteredOptions = this.selectControl.valueChanges
    .pipe(
      startWith(''),
      debounceTime(450),
      takeUntil(this._onDestroy),
      map(() =>
        this.filter()
      )
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    if ('selectControl' in changes || 'data' in changes) {
      if (this.selectControl.value && this.data && this.data.length > 0) {
        const value = this.data.find(item => item[this.dataDisplayValue].toLowerCase() === this.selectControl.value.toLowerCase());
        this.selectedValue = value || null;
      } else {
        this.selectedValue = null;
      }

    }
  }

  selectControlChange(event: MatAutocompleteSelectedEvent): void {
    const value = event.option.value.toLowerCase();
    this.selectedValue = this.data.find(item => item[this.dataDisplayValue].toLowerCase() === value);
    this.selecteOptionChanged.emit(this.selectedValue);
  }

  inputValueChange() {
    const value = this.data.find(item => item[this.dataDisplayValue].toLowerCase() === this.selectControl.value.toLowerCase());
    this.selectedValue = value || null;
    if (value) {
      this.selecteOptionChanged.emit(this.selectedValue);
    }
  }

  filter() {
    const filterValue = this.selectControl.value ? this.selectControl.value.toLowerCase() : '';
    return !filterValue ? this.data : this.data.filter(option => option[this.dataDisplayValue].toLowerCase().includes(filterValue));
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}
